export const getGeneralReducer = ({ configManagerLite }) => configManagerLite.general;

export const isLoadingGeneralSelector = (state) => getGeneralReducer(state).isLoading;
export const configDataSelector = (state) => getGeneralReducer(state).configData;
export const httpResponseSelector = (state) => getGeneralReducer(state).httpResponse;
export const scrapeTaskSelector = (state) => getGeneralReducer(state).scrapeTask;
